import { principles } from '@/mocks/site';

export default function BrandIntro() {
  return (
    <section id="about" className="w-full scroll-mt-24 border-y border-background-200 bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
        <div className="order-2 lg:order-1">
          <span className="text-sm font-bold text-secondary-700">关于猎奇吃瓜</span>
          <h2 className="mt-2 font-heading text-2xl leading-snug text-foreground-950 md:text-3xl">
            我们不做猎奇，我们只是把离谱的事讲清楚
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            猎奇吃瓜是一个内容分享栏目，专注收集那些让人"啊？"一声的生活现场。这里没有精心设计的反转，只有真实发生过的魔幻操作。
            我们把散落在各处的沙雕新闻、奇葩人物和搞笑怪事整理成有头有尾的故事，让你在通勤、午休、睡前的碎片时间里，笑着把瓜吃完。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们相信，好笑和认真并不冲突。越是离谱的事，越值得被好好讲清楚。
          </p>
          <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((item) => (
              <div key={item.title} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700">
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-sm font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="order-1 overflow-hidden rounded-lg border border-background-200 lg:order-2">
          <div className="h-72 w-full bg-background-100 md:h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=Bold%20flat%20editorial%20illustration%20of%20an%20open%20notebook%20with%20quirky%20story%20doodles%2C%20a%20melon%20slice%20and%20a%20magnifying%20glass%2C%20warm%20cream%20background%2C%20tomato%20red%20amber%20and%20teal%20color%20blocks%2C%20minimal%20geometric%20shapes%2C%20high%20contrast%2C%20no%20text&width=1000&height=1000&seq=gq-brand-01&orientation=squarish"
              alt="记录离谱故事的笔记本与放大镜插画"
              title="猎奇吃瓜 - 内容整理与分享"
              className="h-full w-full object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}